import { z } from 'zod';

export const userSignupVerifyOtpSchema = z.object({
  sessionId: z.uuid("Session Id is required"),
  id: z.uuid("Id is required"),
  otpCode: z
    .string()
    .length(6, 'OTP must be 6 digits')
    .regex(/^\d{6}$/, 'OTP must contain only numbers'),
});

export type UserSignupVerifyOtpFormValues = z.infer<
  typeof userSignupVerifyOtpSchema
>;